import { Info, Label, Row } from 'hatch-components';
import styled from 'styled-components';

export const StyledInfoWrapper = styled.div(
  ({
    theme: {
      spacing,
      responsive: { mobile },
    },
  }) => ({
    height: 14,
    marginLeft: spacing.xs,
    [mobile]: {
      display: 'none',
    },
    width: 14,
  }),
);

export const StyledInfoIcon = styled(Info)(() => ({}));

export const StyledObservesDaylightSavingsTimeRow = styled(Row)(
  ({ theme: { spacing } }) => ({
    alignItems: 'center',
    marginBottom: spacing.md,
  }),
);

export const StyledObservesDaylightSavingsTimeLabel = styled(Label)(
  ({ theme: { spacing } }) => ({
    padding: `0 0 0 ${spacing.sm}`,
  }),
);
